import {gsap} from 'gsap';

( function( app ) {
  const COMPONENT = {
    init: function() {
      if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
        return;
      }

      $( '.cutout-callout' ).each( function() {
        const gradients = $( this ).find( '.js-cutout-gradient' ).toArray();

        if ( gradients.length < 2 ) {
          return;
        }

        const tl = gsap.timeline( {
          repeat: -1,
          defaults: {
            duration: 1.5,
            ease: 'sine.inOut',
          },
        } );

        tl
            .set( gradients, {scale: 0.5} )
            .to( gradients[0], {scale: 0.8, repeat: 1, yoyo: true} )
            .to( gradients[1], {scale: 0.8, repeat: 1, yoyo: true}, '-=1' );
      } );
    },
    finalize: function() {
    },
  };
  app.registerComponent( 'cutout-callout', COMPONENT );
} )( app );
